import React from 'react';
import { Outlet } from "react-router-dom";
import { FaReceipt } from "react-icons/fa";

function PaymentHistory() {
    return (
        <div>
            <div className="page-header">
                <h1>
                    <FaReceipt /> <span>Payment History</span>
                </h1>
            </div>
            <Outlet />
        </div>
    )
}
export default PaymentHistory;

